import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
type PoliciesSectionProps = {
  children: ReactNode;
};
export default function PoliciesSection(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section><ContentWrapper>{children}</ContentWrapper></section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}